import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { UiButton } from 'ui-components';
import { startTour, updateShepherdSettings } from 'store';
import { usePermission } from 'hooks';
import { getEnv } from 'utils';
import QuickGuide from './QuickGuide';

const FeedbackModalStructure = ({ handleStep, toggleHamburger }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { userPermission } = usePermission();

  const { permission: permi_support_add } = useMemo(
    () => userPermission('Ticket', 'store'),
    [userPermission]
  );

  const handleStartTour = async (event) => {
    setLoading(true);
    try {
      await dispatch(startTour());
      await dispatch(updateShepherdSettings());
      toggleHamburger(event);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className='feedback-component-body'>
        <QuickGuide />
        <div className='body-ability'>
          <span>{t('support:learnAllFeaturesOfSystem')}</span>
          <div className='button--wrapper'>
            <UiButton
              onClick={toggleHamburger}
              href={getEnv('REACT_APP_BLOG_URL')}
              target='_blank'
              variant='outlined'
              className='ml-5'
              color='primary'
              textColor='#199da3'
            >
              {t('support:box.goToBlog.buttonText')}
            </UiButton>
            <UiButton
              variant='outlined'
              className='mr-5'
              color='primary'
              onClick={handleStartTour}
              disabled={loading}
              loading={loading}
            >
              {t('support:box.startTour.buttonText')}
            </UiButton>
          </div>
        </div>

        {permi_support_add && (
          <div className='body-support'>
            <span>{t('support:reportPageBugs')}</span>
            <div className='button--wrapper'>
              <UiButton
                variant='outlined'
                color='primary'
                onClick={() => handleStep('step_2')}
              >
                {t('support:sendFeedback')}
              </UiButton>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

FeedbackModalStructure.propTypes = {
  handleStep: PropTypes.func,
  toggleHamburger: PropTypes.func,
};

export default FeedbackModalStructure;
